// material-ui
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// project import
import NavGroup from './NavGroup';
import menuItem from '../../../../../menu-items';
import { useSelector } from 'react-redux';
import { getItem } from '@utils/localStorage';
// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

const normalizeRole = (role) => String(role?.name || role?.slug || role?.code || role?.role || role?.id || role || '').trim().toLowerCase();

const expandRoles = (roles) => {
  const roleSet = new Set(roles.map(normalizeRole).filter(Boolean));

  if (roleSet.has('1') || roleSet.has('administrator') || roleSet.has('super_admin') || roleSet.has('super-admin') || roleSet.has('admin')) {
    roleSet.add('admin');
  }

  if (roleSet.has('2')) {
    roleSet.add('student');
  }

  if (roleSet.has('3')) {
    roleSet.add('teacher');
  }

  if (roleSet.has('4')) {
    roleSet.add('editor');
  }
  return Array.from(roleSet);
};

const parseJson = (key, fallback) => {
  try {
    const value = getItem(key);
    return value ? JSON.parse(value) : fallback;
  } catch {
    return fallback;
  }
};

const parseStoredRoles = () => {
  const userData = parseJson('userData', {});
  const roles = userData?.roles || parseJson('roles', []);

  const rolesArray = Array.isArray(roles) ? roles : (roles ? [roles] : []);
  return expandRoles(rolesArray);
};

const filterMenuByRole = (items, userRoles) => {
  return items
    .map((item) => {
      const filteredChildren = item.children ? filterMenuByRole(item.children, userRoles) : [];

      const hasPermission =
        !item.roles || item.roles.map(normalizeRole).some(role => userRoles.includes(role));

      if (filteredChildren.length > 0 && hasPermission) {
        return { ...item, children: filteredChildren };
      }

      if (!item.children && hasPermission) {
        return item;
      }

      return null;
    })
    .filter(Boolean);
};

const getVisibleMenu = (items) => {
  return items
    .map((item) => {
      const children = item.children ? getVisibleMenu(item.children) : [];

      if (children.length > 0) {
        return { ...item, children };
      }

      if (!item.children && item.visible !== false) {
        return item;
      }

      return null;
    })
    .filter(Boolean);
};

export default function Navigation() {
  const reduxRoles = useSelector(state => {
    const roles = state.auth?.data?.userData?.roles || state.auth?.user?.roles || state.auth?.roles || [];
    const rolesArray = Array.isArray(roles) ? roles : (roles ? [roles] : []);
    return expandRoles(rolesArray);
  });
  const userRoles = reduxRoles.length > 0 ? reduxRoles : parseStoredRoles();
  const filteredItems = filterMenuByRole(menuItem.items, userRoles);
  const visibleItems = filteredItems.length > 0 ? filteredItems : getVisibleMenu(menuItem.items);
  const navGroups = visibleItems.map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });

  return <Box sx={{ px: 1.5, py: 2 }}>{navGroups}</Box>;
}
